import { Component, input, output, signal, inject, LOCALE_ID } from '@angular/core';

@Component({
  selector: 'app-import-global-modal',
  standalone: true,
  imports: [],
  templateUrl: './import-global-model.html',
    styleUrl: './import-global-model.scss',
})
export class ImportGlobalModal {
  private locale = inject(LOCALE_ID);

  globalAttributes = input.required<any[]>();
  existingKeys = input<string[]>([]);

  onClose = output<void>();
  onConfirm = output<any>();

  selectedAttr = signal<any>(null);
  duplicateError = signal<boolean>(false);

  get isArabic(): boolean {
    return this.locale.startsWith('ar');
  }

  getTitle(obj: { titleEn: string; titleAr: string }): string {
    return this.isArabic ? (obj.titleAr || obj.titleEn) : obj.titleEn;
  }

  handleSelect(event: any) {
    const id = event.target.value;
    const attr = this.globalAttributes().find((a) => String(a.attributeKey.id) === String(id));
    this.selectedAttr.set(attr ?? null);

    if (attr) {
      const existing = this.existingKeys().map((k) => k.toLowerCase());
      this.duplicateError.set(existing.includes(attr.attributeKey.titleEn.toLowerCase()));
    } else {
      this.duplicateError.set(false);
    }
  }

  handleConfirm() {
    const attr = this.selectedAttr();
    if (!attr || this.duplicateError()) return;
    
    this.onConfirm.emit(attr);
    this.selectedAttr.set(null);
    this.duplicateError.set(false);
  }
}